export const ACCOUNT_AUTH_VIEWS = {
  LOGIN: 'login',
  SIGNUP: 'signup'
};

export const SESSION_PASSWORD_MIN_LENGTH = 8;
export const SESSION_USERNAME_MAX_LENGTH = 64;
export const SESSION_BIO_MAX_LENGTH = 10_000;
export const SESSION_LOCATION_MAX_LENGTH = 255;

export const SESSION_ENDED_EVENT = 'session-ended';
export const SESSION_END_REASONS = {
  expired: 'expired'
};
